export default "__VITE_ASSET__CyHGZZUl__"